import React, { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import { FormContext } from '../../../common/form/FormContext';
import FormPanel from '../../../common/form/FormPanel';
import ResourceCommonFormItems from '../ResourceCommonFormItems';
import { RESOURCE_FIELD_NAMES } from '../resourceConstants';
import ResourceHiringInfoFormItems from './ResourceHiringInfoFormItems';
import ResourceScheduleFormItems from './ResourceScheduleFormItems';

type ResourceFormPropTypes = {
    setValidation?: Dispatch<SetStateAction<any>>;
    hasLinkedActivities?: boolean;
    hiddenFields?: Record<string, boolean>;
    disabledFields?: Record<string, boolean>;
};
export default function ResourceFormItems({
    setValidation,
    hasLinkedActivities,
    hiddenFields = {},
    disabledFields = {}
}: ResourceFormPropTypes) {
    const { validation, state, handleChange } = useContext(FormContext);

    useEffect(() => {
        if (setValidation) {
            setValidation(validation);
        }
    });

    return (
        <FormPanel>
            <ResourceCommonFormItems hiddenFields={hiddenFields} disabledFields={disabledFields} />
            {!hiddenFields[RESOURCE_FIELD_NAMES.hiringInfoSection] && <ResourceHiringInfoFormItems />}
            {!hiddenFields[RESOURCE_FIELD_NAMES.scheduleSection] && (
                <ResourceScheduleFormItems hasLinkedActivities={hasLinkedActivities} />
            )}
        </FormPanel>
    );
}
